function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "M0 13.8174C0 6.63768 5.8203 0.817383 13 0.817383V0.817383C20.1797 0.817383 26 6.63768 26 13.8174V13.8174C26 20.9971 20.1797 26.8174 13 26.8174V26.8174C5.8203 26.8174 0 20.9971 0 13.8174V13.8174Z",
  fill: "#004152"
});

var _ref3 = React.createElement("path", {
  d: "M18.8804 14.0886C19.0399 13.9291 19.0399 13.7058 18.8804 13.5463L15.6902 10.3561C15.5307 10.1966 15.2755 10.1966 15.1479 10.3561L14.5098 10.9942C14.3503 11.1218 14.3503 11.377 14.5098 11.5365L16.1368 13.0359L7.38282 13.0359C7.15951 13.0359 7 13.2273 7 13.4187L7 14.1843C7 14.4077 7.15951 14.5672 7.38282 14.5672L16.1368 14.5672L14.5098 16.0984C14.3503 16.258 14.3503 16.5132 14.5098 16.6408L15.1479 17.2788C15.2755 17.4383 15.5307 17.4383 15.6902 17.2788L18.8804 14.0886Z",
  fill: "white"
});

var SvgArrowRightInCircleFill = function SvgArrowRightInCircleFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowRightInCircleFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right-in-circle-fill.26a4596a.svg";
export { ForwardRef as ReactComponent };